const FORM_KEYS = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  unpackType: 'unpackType',
  itemToUnpack: 'itemToUnpack',
};

export default FORM_KEYS; 